import angular from "angular";
import uiRouter from "angular-ui-router";
import timeTitleComponent from "./time-title.component";
import timeTitleListComponent from "./time-title-list.component";
import TimeTitleService from "./time-title.service";

let titleModule = angular
  .module("time-title", [uiRouter])

  .service("TimeTitleService", TimeTitleService)
  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $urlRouterProvider.otherwise("/login");
    $stateProvider
      .state("time-title", {
        component: "timeTitle",
      })
      .state("time-title.list", {
        url: "/time-title",
        component: "timeTitleList",
      });
  })

  .component("timeTitle", timeTitleComponent)
  .component("timeTitleList", timeTitleListComponent)
  .name;

export default titleModule;



// WEBPACK FOOTER //
// ./client/app/components/title-time/time-title.js